import { useState } from 'react'
import { createModel } from 'hox'
import useStorageState from '../hooks/useStorageState'
import { PaginationProps } from 'antd/es/pagination'
import { ISelectOption } from '@/components/YhFormBox/Types'
import { IPgProps, ISelectOptions } from '@/types/AppTypes'
import { messageService } from '@/views/message/messageService'

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.pageSize,
        current: pg.pageNum,
    }
}
export function transPgToPaginationTotal(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.pageSize,
        current: pg.pageNum,
    }
}

export function fn(): Promise<ISelectOption[]> {
    let arr: ISelectOption[] = []
    return Promise.resolve(arr)
}

export type RoleType = {
    id: string
    name: String
}
export type UserType = {
    id: string
    userName: string
    password: String
    token: string
    shopId: string
    shopName: string
    shopCode: string
    loginType?: 'account' | 'token'
    [key: string]: any
}


export interface IOfficeLookInfo {
    visible: boolean
    url: string
}

export interface ICiStaticResourcesType {
    image: string
    video: string
}

export type LoadingType = { loadingVisible: boolean; txt: string }

type GlobalModelType = {
    user: UserType
    setUser: (e: UserType) => void
    resetUser: () => void

    ciDict: any
    setCiDict: (e: any) => void
    resetCiDict: () => void
    ciGetTreeNodeValue: (string) => string | undefined

    ciStaticResources: ICiStaticResourcesType
    setCiStaticResources: (e: ICiStaticResourcesType) => void
    resetCiStaticResources: () => void
    getCiImgUrl: (string) => string

    toggleMenu: () => void
    cm: CmType
    resetCm: () => void
    loadingInfo: LoadingType
    setLoadingInfo: (origin: LoadingType) => void

    whDs: ISelectOptions[]
    // warehouseloadDataAll: (shopCode?: string) => void,

    beDs: ISelectOptions[]
    setBeDs: (value: ISelectOptions[] | ((previousState?: ISelectOptions[] | undefined) => ISelectOptions[])) => void
    // beLoadDataAll: () => void,
    requestCacheAll: (shopCode?: string) => void

    shopDs: ISelectOptions[]
    setShopDs: (origin: ISelectOptions[]) => void

    CustomerData: ISelectOptions[]
    setCustomerData: (origin: ISelectOptions[]) => void
    clearCustomerData: (origin: ISelectOptions[]) => void

    supplierDs: ISelectOptions[]
    // supplierLoadDataAll: (shopCode?: string) => void,

    resourceAuth: string[]
    setResourceAuth: (origin: string[]) => void

    menuAuth: string[]
    setMenuAuth: (origin: string[]) => void

    // fetchSupplierList: (value: string) => Promise<ISelectOption[]>,
    // fetchOfferList: (value: string) => Promise<ISelectOption[]>,
    // fetchSalesList: (value: string) => Promise<ISelectOption[]>,
    // fetchSaleBySupplier: (value: string) => Promise<ISelectOption[]>,
    unreadNum: number,
    searchMsgUnreadNum: () => void

    officeLookInfo: IOfficeLookInfo,
    setOfficeLookInfo: (val: IOfficeLookInfo) => void
}

const initUserState = {
    id: '',
    userName: '',
    password: '',
    token: '',
    shopId: '',
    shopName: '',
    shopCode: '',
}

type CmType = {
    collapsed: boolean
}
const initCmState = {
    collapsed: false,
}
//返回列表韦options的格式
export const transOptions = (list: any[]) => {
    return list.length != 0 ? list.map((item) => ({ label: item.name, value: item.code, disabled: item.enable === 0 ? true : false })) : []
}
function useModel(): GlobalModelType {
    //客户数据
    const [CustomerData, setCustomerData, clearCustomerData] = useStorageState<ISelectOptions[]>('customerList', [])
    //所有仓库
    const [whDs, setwhDs] = useStorageState<ISelectOptions[]>('franchisee.waerhouseDs', [])
    //经营实体
    const [beDs, setBeDs] = useStorageState<ISelectOptions[]>('beDs', [])
    //所有门店
    const [shopDs, setShopDs] = useStorageState<ISelectOptions[]>('franchisee.shopDs', [])
    //用户所有菜单权限
    const [menuAuth, setMenuAuth] = useStorageState<string[]>('franchisee.user.menus', [])
    //用户所有资源权限
    const [resourceAuth, setResourceAuth] = useStorageState<string[]>('franchisee.user.resource', [])
    //用户所有信息
    const [user, setUser, resetUser] = useStorageState<UserType>('franchisee.user', initUserState)
    // //所有供应商
    const [supplierDs, setSupplierDs] = useStorageState<ISelectOptions[]>('franchisee.supplierDs', [])
    const [cm, setCm, resetCm] = useStorageState<CmType>('franchisee.cm', initCmState)

    //ci 数据字典
    const [ciDict, setCiDict, resetCiDict] = useStorageState<UserType>('ci.dictTree', initUserState)

    //根据code 返回对应的value 字典值 （例如， 币种的符号）
    const ciGetTreeNodeValue = (code: string): any => {
        return ciDict.find((i) => i.dictCode === code)?.dictName
    }

    //ci 图片资源地址
    const [ciStaticResources, setCiStaticResources, resetCiStaticResources] = useStorageState<ICiStaticResourcesType>('ci.staticResources', { image: '', video: '' })
    const getCiImgUrl = (md5: string) => {
        if (ciStaticResources && ciStaticResources.image) {
            return `${ciStaticResources.image}${md5}`
        } else {
            return ''
        }
    }

    //全局loading
    const [loadingInfo, setLoadingInfo] = useState<LoadingType>({ loadingVisible: false, txt: '' })

    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed,
        })
    }
    //初始页数
    const searchParams = { pageSize: -1, pageNum: 1 }


    // //初始所有实体
    const beloadDataAll = async () => {
        // let { retData } = await commonService.bePage({})
        // setBeDs(
        //     retData.map((item) => ({
        //         label: item.name,
        //         value: item.id,
        //         id: item.id,
        //         phone: item.phone,
        //         address: item.address,
        //     }))
        // )
    }

    //所有缓存加载
    const requestCacheAll = (shopId = user.shopId) => {
        // beloadDataAll()
    }

    const [unreadNum, setUnreadNum] = useState<number>(0)

    const [officeLookInfo, setOfficeLookInfo] = useState<IOfficeLookInfo>({ visible: false, url: '' })

    //查询未读消息数
    const searchMsgUnreadNum = async () => {
        const { retData } = await messageService.unreadNum()
        setUnreadNum(retData)
    }

    return {
        user,
        setUser,
        resetUser,
        cm,
        toggleMenu,
        resetCm,
        loadingInfo,
        setLoadingInfo,
        whDs,
        requestCacheAll,
        supplierDs,
        // beDs,
        beDs,
        setBeDs,
        shopDs,
        setShopDs,
        resourceAuth,
        setResourceAuth,
        menuAuth,
        setMenuAuth,
        // warehouseloadDataAll,
        // fetchSupplierList,
        // fetchOfferList,
        // fetchSalesList,
        // fetchSaleBySupplier,
        CustomerData,
        setCustomerData,
        clearCustomerData,
        ciDict,
        setCiDict,
        resetCiDict,
        ciGetTreeNodeValue,
        ciStaticResources, setCiStaticResources, resetCiStaticResources,
        getCiImgUrl,
        unreadNum,
        searchMsgUnreadNum,
        officeLookInfo,
        setOfficeLookInfo
    }
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel
